import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from './redux/actions';
import { EditRpmScheduleModalPages, getPagesDetails } from './ModalsMetadata';
import DropdownMenu from '../../components/DropdownMenu/DropdownMenu';
import { ORG_FEATURES, orgFeatureEnabled } from '../../utils/userPermissions';

function ModalsVisibilityMenu (props) {
  const { modalId, pagesVisibility, init, changePageVisibility } = props;
  const engagementMessagesEnabled = orgFeatureEnabled(ORG_FEATURES.engagement_messages_enabled);

  useEffect(() => {
    if (!pagesVisibility) {
      init(modalId);
    }
  }, [pagesVisibility]);

  return (
    <DropdownMenu
      title="Select pages"
      icon="visibility-icon"
      withCheckboxes
      options={pagesVisibility?.filter(p => !engagementMessagesEnabled ? p.id !== EditRpmScheduleModalPages.engagementMessages.id : true).map(page => ({
        onSelect: () => changePageVisibility(modalId, page.id),
        label: page.name,
        disabled: page.isRequired,
        checked: page.visible,
      }))}
    />
  );
};

const mapStateToProps = (state, props) => {
  return {
    pagesVisibility: getPagesDetails(state.modalsVisibility.pagesVisibility.find(v => v.id === props.modalId)),
  };
};

ModalsVisibilityMenu.propTypes = {
  modalId: PropTypes.string,
  changePageVisibility: PropTypes.func,
  init: PropTypes.func,
  pagesVisibility: PropTypes.array,
};

const mapDispatchToProps = dispatch => ({
  init: modalId => dispatch(actions.resetToDefault(modalId)),
  changePageVisibility: (modalId, pageId) => dispatch(actions.changePageVisibility(modalId, pageId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalsVisibilityMenu);
